import React from "react";
import "./RegisterWithUs.css";
import { useTranslation } from "react-i18next";
import RegisterWithUsImage from "../../Images/RegisterWithUs.png";
import { HashLink } from "react-router-hash-link";

const RegisterWithUs = () => {
  const { t, i18n } = useTranslation();

  return (
    <section
      className={`register-with-us my-8 lg:px-16 md:px-16 px-5 py-16 ${
        i18n.language == "en" ? "text-left" : "text-right"
      }`}
      dir={i18n.language == "en" ? "ltr" : "rtl"}
    >
      <div className="lg:grid md:grid grid-cols-12">
        <div className=" lg:col-span-6 md:col-span-6 col-span-12 my-auto mb-12">
          <p
            style={{
              color: "#44add2",
              fontWeight: "bold",
            }}
            className="text-2xl"
          >
            {t("home.sec5Title")}
          </p>
          <p className="mt-2 mb-8  text-3xl lg:w-96 lg:leading-relaxed md:leading-relaxed leading-10">
            {t("home.sec5Content")}
          </p>
          <div className="flex justify-start lg:-translate-x-0 md:-translate-x-0 -translate-x-5">
            <button className="btn-register col-span-12 lg:block md:block flex justify-center p-0">
              <HashLink
                to={
                  i18n.language === "en"
                    ? "/en/register#ConferanceLogin"
                    : "/ar/register#ConferanceLogin"
                }
              >
                {t("common.register")}
              </HashLink>
            </button>
            <button className="btn-view h-fit my-auto p-0">
              <HashLink
                to={
                  i18n.language === "en"
                    ? "/en/sponsor#sponserForm"
                    : "/ar/sponsor#sponserForm"
                }
              >
                {t("common.exhibit")}
              </HashLink>
            </button>
          </div>
        </div>
        <div className=" lg:col-span-6 md:col-span-6 col-span-12 mx-2">
          <img
            src={RegisterWithUsImage}
            className=" mx-auto w-full my-4"
            alt="minister_image"
          />
        </div>
      </div>
    </section>
  );
};

export default RegisterWithUs;
